var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "product-reviews" }, [
    _c(
      "ul",
      { staticClass: "reviews" },
      _vm._l(_vm.reviews, function (review, index) {
        return _c("li", { key: index, staticClass: "review-item" }, [
          _c("div", { staticClass: "review-item-header" }, [
            review.date
              ? _c("div", { staticClass: "review-date" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("formatDate")(review.date)) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "review-item-title" }, [
              _c("h3", [_vm._v(" " + _vm._s(review.title) + " ")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "review-item-subtitle" }, [
              _c("h4", [_vm._v(_vm._s(review.subtitle))]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "review-item-description" }, [
            _vm._v("\n        " + _vm._s(review.review) + "\n      "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "points-container" }, [
            _c("div", { staticClass: "points" }, [
              _c("span", { staticClass: "number" }, [
                _vm._v(
                  "\n            " + _vm._s(review.points) + "\n          "
                ),
              ]),
            ]),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }